import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import { securedFetch } from "../../auth/authService";
import { getSortAndFilterQueryString } from "../../view/urlService";
import { ACTION_REMEDIATION_CHANGED } from "./RemediationPageReducer";
import { REMEDIATE_API } from "../../vars";


export function listPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${REMEDIATE_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(ACTION_REMEDIATION_CHANGED)({ remediations: data.page }));
        return { rules: data.page, totalPages: data.total, totalRecords: data.records }
    });

}



